import React from 'react'
import { URL_POST_CREAOT } from '../../router/Url';

export const PostWo = ({id_code,
            type,
            programado,
            responsable,
            name,
            type_pending,
            planta,
          priority}) => {
   return new Promise(async (resolve, reject) => {
      let query = await fetch(URL_POST_CREAOT,{
        method: 'POST',
        headers: {
          'authorization': "marcuxo",
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id_code:id_code,
            type:type,
            programado:programado,
            responsible:responsable,
            name:name,
            type_pending:type_pending,
            planta:planta,
            priority:priority
        })
      })
      let responsito = await query.json();
      console.log(responsito);
      if(responsito){
        resolve(responsito)
      }else{
        resolve(responsito)
      }
    })
}
